<template>
  <div class="list">
    <notifications></notifications>
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
            ></head-menu-filter>

            <div class="row mb-2">
              <div
                class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10"
              >
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.geplantVon"
                        class="form-control input"
                        type="date"
                        placeholder=" "
                      />
                      <label>{{ $t("global.plannedFrom") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.geplantBis"
                        class="form-control input"
                        type="date"
                        placeholder=" "
                      />
                      <label>{{ $t("global.plannedTill") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.statusId"
                        label="bezeichnung"
                        :options="aktivitaetStatuse"
                        :placeholder="$t('global.status')"
                        :reduce="(s) => s.id"
                      >
                        <span slot="no-options">{{ $t("global.taptosearch") }}</span>
                      </v-select>
                      <label>{{ $t("global.status") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <single-select-firma
                      id="aktivitaeten-firma"
                      :firma="filters.firma"
                      :label="$t('global.contactcompany')"
                      :allowOpen="false"
                      editable
                      @confirmed="setKontaktFirma"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <single-select-person
                      id="verantwortlicher-aktivitaeten"
                      :person="filters.verantwortlicher"
                      :label="$t('global.Responsible')"
                      :allowOpen="false"
                      editable
                      @confirmed="setVerantwortlicher"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters['bezeichnung']"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.designation") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <single-select-person
                      id="jug-aktivitaeten"
                      :person="filters.jugPerson"
                      :label="$t('global.youth')"
                      :allowOpen="false"
                      editable
                      @confirmed="setJugPerson"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <single-select-firma
                      id="hof-aktivitaeten"
                      :firma="filters.hofFirma"
                      :label="$t('global.farmname')"
                      :allowOpen="false"
                      editable
                      @confirmed="setHofFirma"
                    />
                  </div>
                </div>
                <!-- <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.selectedProzesse"
                        label="bezeichnung"
                        :options="prozesse"
                        :reduce="(p) => p.id"
                        :multiple="true"
                        :placeholder="$t('global.Process')"
                      >
                        <span slot="no-options">{{ $t("global.taptosearch") }}</span>
                      </v-select>
                      <label>{{ $t("global.Process") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.selectedCheckpunkte"
                        label="label"
                        :options="checkpunkte"
                        :reduce="(c) => c.titel"
                        :multiple="true"
                        :placeholder="$t('global.actualCheckpoint')"
                      >
                        <span slot="no-options">{{ $t("global.taptosearch") }}</span>
                      </v-select>
                      <label>{{ $t("global.actualCheckpoint") }}</label>
                    </div>
                  </div>
                </div> -->
                <filter-search-reset-button />
              </div>
            </div>
          </div>
        </div>
        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="navbarTitel"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
              :gesamtanzahl="gesamtanzahl"
            ></head-menu>
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row mt-2 d-flex justify-content-between">
                  <div class="ml-4 mr-2"></div>
                  <div class="mr-4">
                    <button
                      class="btn btn-danger"
                      @click="oeffneLoeschenModal"
                      v-if="berechtigungen.m_lead.delete"
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-trash"
                        class="mr-2"
                      />
                      <span>{{ $t("global.delete") }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row block belegliste">
              <div class="w-100-p">
                <div>
                  <b-table
                    ref="selectableTable"
                    small
                    tbody-tr-class="item"
                    :items="listData"
                    :fields="fields"
                    sort-icon-left
                    no-local-sorting
                    @sort-changed="sortingChanged"
                    fixed
                    selectable
                    select-mode="range"
                    @row-dblclicked="details"
                    thead-tr-class="pointer"
                  >
                    <template slot="top-row" slot-scope="{ fields }">
                      <td
                        class="no-pointer"
                        v-for="field in fields"
                        :key="field.key"
                      >
                        <b-input
                          v-if="
                            field.key != 'selected' &&
                            field.searchable !== false
                          "
                          size="sm"
                          v-model="filters[field.key]"
                          :placeholder="field.label"
                          autocomplete="off"
                        />
                      </td>
                    </template>

                    <template v-slot:head(selected)="header">
                      <b-form-checkbox
                        ref="headerCheckbox"
                        v-model="header.selected"
                        @input="selectAllRows(header)"
                      ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(selected)="row">
                      <b-form-checkbox
                        v-model="row.item.selected"
                        @input="onRowSelected(row)"
                      ></b-form-checkbox>
                    </template>

                    <template #cell(uebernehmen)="row">
                      <b-button
                        size="sm"
                        variant="outline-primary"
                        @click="uebernehmen(row.item)"
                        v-tooltip="$t('global.assigntome')"
                      >
                        <font-awesome-icon icon="user-plus" />
                      </b-button>
                    </template>

                    <template #cell(details)="row">
                      <b-button
                        @click="row.toggleDetails"
                        class="m-0"
                        variant="outline-primary"
                        size="sm"
                        v-tooltip="$t('global.description')"
                      >
                        <font-awesome-icon
                          :icon="
                            row.detailsShowing
                              ? 'fa-chevron-up'
                              : 'fa-chevron-down'
                          "
                        />
                      </b-button>
                    </template>
                    <template #row-details="row">
                      <pre
                        class="text-left"
                        style="
                          font-size: 16px;
                          font-family: 'Open Sans', sans-serif;
                        "
                        v-html="
                          row.item.beschreibung || $t('global.nodescription')
                        "
                      />
                    </template>

                    <template #table-busy>
                      <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </template>

                    <template #empty>
                      <div
                        v-if="ladeFehler"
                        class="text-center text-danger my-2"
                      >
                        <strong>{{ $t("global.errorwhileloading") }}</strong>
                      </div>
                      <div
                        v-if="!ladeFehler"
                        class="text-center text-primary my-2"
                      >
                        <strong>{{ $t("global.nodataavailable") }}</strong>
                      </div>
                    </template>
                  </b-table>
                  <infinite-loading
                    :identifier="infiniteId"
                    @infinite="(s) => infiniteHandler(s, 'app-api')"
                  >
                    <div slot="spinner">{{ $t("global.loadmoredata") }}</div>
                    <div slot="no-more">{{ $t("global.nofurtherdata") }}</div>
                    <div slot="no-results">
                      {{ $t("global.nofurtherdatafound") }}
                    </div>
                  </infinite-loading>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loeschen-modal
      id="aktivitaeten-loeschen-modal"
      @confirmed="loeschen"
      :multiple="true"
    />

    <messagebox-count
      :headerText="$t('global.personsdeleted')"
      id="count-delete-alert-msgbox"
      :ok="true"
      :cancel="false"
      :okText="$t('global.ok')"
      :cancelText="$t('global.cancel')"
    />

    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>

<script>
import Api from "@/api/Api";
import AppApi from "@/api/AppApi";
import { LADE_AUSWAHLWERTE_CRM } from "@/store/crm/actions.type";
import { LADE_AUSWAHLWERTE_PROZESS } from "@/store/prozess/actions.type";
import { LADE_AUSWAHLWERTE_CHECKPUNKT } from "@/store/checkpunkt/actions.type";

import HeadMenu from "@/components/HeadMenu";
import HeadMenuFilter from "@/components/HeadMenuFilter";
import Navbar from "@/components/Navbar";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import store from "@/store";
import page from "@/mixins/Page";
import dashboard from "@/mixins/Dashboard";
import filter from "@/mixins/Filter";
import SingleSelectPerson from "@/components/global/SingleSelectPerson.vue";
import SingleSelectFirma from "@/components/global/SingleSelectFirma.vue";
import FilterSearchResetButton from "@/components/Buttons/FilterSearchResetButton";

export default {
  name: "Aktivitaeten",
  components: {
    Navbar,
    HeadMenu,
    HeadMenuFilter,
    LoeschenModal,
    SingleSelectPerson,
    SingleSelectFirma,
    FilterSearchResetButton,
  },
  mixins: [page, dashboard, filter],
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
  },
  store,
  data() {
    return {
      aktivitaetenliste: [],
      isDisabled: true,
      fields: [
        { key: "selected", label: "" },
        {
          key: "geplantdatum",
          searchable: false,
          sortable: true,
          label: this.$t("global.planned"),
          formatter: (value, key, item) => {
            return value ? value + " - " + item.geplantzeit : "-";
          },
        },
        {
          key: "status.bezeichnung",
          searchable: false,
          sortable: true,
          label: this.$t("global.status"),
        },
        {
          key: "firma.name",
          searchable: false,
          sortable: true,
          label: this.$t("global.contactcompany"),
        },
        {
          key: "verantwortlicher",
          searchable: false,
          sortable: true,
          label: this.$t("global.Responsible"),
          formatter: (value) => {
            if (!value) return "-";
            if (Array.isArray(value)) {
              return (
                value
                  .map((v) => v?.personName)
                  .filter(Boolean)
                  .join(", ") || "-"
              );
            }
            return value?.personName || value;
          },
        },
        {
          key: "bezeichnung",
          sortable: true,
          label: this.$t("global.designation"),
        },
        {
          key: "jugendlicher.personName",
          searchable: false,
          sortable: false,
          label: this.$t("global.youth"),
        },
        {
          key: "hofname",
          searchable: false,
          sortable: false,
          label: this.$t("global.farmname"),
        },
        // {
        //   key: "prozess_name",
        //   searchable: false,
        //   sortable: false,
        //   label: this.$t("global.Process"),
        // },
        // {
        //   key: "aktueller_checkpoint",
        //   searchable: false,
        //   sortable: false,
        //   label: this.$t("global.actualCheckpoint"),
        // },
        {
          key: "details",
          searchable: false,
          sortable: false,
          label: this.$t("global.description"),
        },
        {
          key: "uebernehmen",
          searchable: false,
          sortable: false,
          label: "",
        },
      ],
    };
  },
  computed: {
    queryParams: function () {
      var params = {};

      // Kennzeichnet den Aufruf aus der Aktivitätenliste, damit die Geschäftsstelle alle Aktivitäten erhält
      params.aktivitaetenliste = true;

      params.statusId = this.setQueryParam(this.filters.statusId);
      params.resp = this.setQueryParam(this.filters.verantwortlicher?.id);
      params.firma = this.setQueryParam(this.filters.firma?.id);
      params.bezeichnung = this.setQueryParam(this.filters["bezeichnung"]);
      params.jugId = this.setQueryParam(this.filters.jugPerson?.id);
      params.hofId = this.setQueryParam(this.filters.hofFirma?.id);
      params.prozessIds = this.filters.selectedProzesse?.length
        ? this.filters.selectedProzesse.join(",")
        : undefined;
      params.checkpointIds = this.filters.selectedCheckpunkte?.length
        ? this.filters.selectedCheckpunkte.join(",")
        : undefined;
      params.geplantVon = this.setQueryParam(this.filters.geplantVon);
      params.geplantBis = this.setQueryParam(this.filters.geplantBis);

      return params;
    },

    navbarTitel: function () {
      return this.$t("global.activities");
    },
    aktivitaetStatuse() {
      return this.$store?.state.crm.aktivitaetstati ?? [];
    },
    prozesse() {
      return this.$store?.state.prozess.prozesse ?? [];
    },
    checkpunkte() {
      return this.$store?.state.checkpunkt.checkpunkte ?? [];
    },
  },
  created() {
    this.initFilter("aktivitaeten-liste", "aktivitaet/", true);
  },
  mounted() {
    if (!this.filters.statusId)
      this.$set(this.filters, "statusId", "17FD0A1A4A1");
    this.$bus.$emit("searchWithFilter");
    if (this.aktivitaetStatuse.length === 0)
      this.$store.dispatch(`crm/${LADE_AUSWAHLWERTE_CRM}`);
    if (this.prozesse.length === 0)
      this.$store.dispatch(`prozess/${LADE_AUSWAHLWERTE_PROZESS}`);
    if (this.checkpunkte.length === 0)
      this.$store.dispatch(`checkpunkt/${LADE_AUSWAHLWERTE_CHECKPUNKT}`);
  },
  methods: {
    details(aktivitaet) {
      this.$router.push({
        name: "aktivitaet",
        params: { id: aktivitaet.id, anzeige: 0 },
      });
    },
    loeschen() {
      AppApi.delete("aktivitaet/", { data: this.selectedIds }).then(
        (response) => {
          this.schliesseLoeschenModal();
          this.listData = this.listData.filter(
            (v) => !this.selectedIds.includes(v.id)
          );
        }
      );
    },
    schliesseLoeschenModal() {
      $("#aktivitaeten-loeschen-modal").modal("hide");
    },

    oeffneLoeschenModal() {
      $("#aktivitaeten-loeschen-modal").modal("show");
    },

    setVerantwortlicher(person) {
      this.$set(this.filters, "verantwortlicher", person);
    },

    setKontaktFirma(firma) {
      this.$set(this.filters, "firma", firma);
    },

    setJugPerson(person) {
      this.$set(this.filters, "jugPerson", person);
    },

    setHofFirma(firma) {
      this.$set(this.filters, "hofFirma", firma);
    },

    setPerson(person) {
      this.$set(this.filters, "person", person);
    },

    sortingChanged(ctx) {
      this.sortDir = ctx.sortDesc;
      this.sortField = ctx.sortBy;
      this.resetLoading(this);
    },
    uebernehmen(aktivitaet) {
      const userId = this.$store.state.mitarbeiter?.person?.id;
      if (!userId) return;
      AppApi.put(`zuweisung-aktivitaet/${aktivitaet.id}/`, [userId]).then(
        () => {
          this.resetLoading(this);
        }
      );
    },    
  },
};
</script>

<style></style>
